import { ShiftDetail } from 'api/services/shift/schema/shift-detail.schema';
import { UseDownloadQRCodePDFOptions } from '../hooks/use-download-qr-code-pdf/use-download-qr-code-pdf.types';

export const pickShiftPDFOptions = (shift: ShiftDetail): UseDownloadQRCodePDFOptions => {
  return {
    shiftName: shift.name,
    location: shift.location.address,
    startDate: shift.startDate,
    endDate: shift.endDate,
    startTime: shift.startTime,
    endTime: shift.endTime,
    isOpusCompany: shift.isCompanyOpus,
  };
};
